document.addEventListener('DOMContentLoaded', () => {
    // Открытие модальных окон
    document.addEventListener('click', (event) => {
        const openButton = event.target.closest('[data-open-modal]');
        if (openButton) {
            event.preventDefault();
            const modalId = openButton.getAttribute('data-open-modal');
            const targetModal = document.getElementById(modalId);

            if (!targetModal) {
                return console.error('Modal not found!');
            }

            targetModal.show();
        }
    });

    // Закрытие модальных окон при клике на элементы закрытия
    document.addEventListener('click', (event) => {
        const closeButton = event.target.closest('[data-close-modal]');
        if (closeButton) {
            event.preventDefault();
            const modal = closeButton.closest('.modal-window');
            if (modal) {
                modal.close();
            }
        }
    });

    // Закрытие модальных окон при клике на полупрозрачный фон
    document.addEventListener('mousedown', (event) => {
        if (event.target.classList.contains('modal-window__body')) {
            const modal = event.target.closest('.modal-window');
            if (modal) {
                modal.close();
            }
        }
    });

    // Закрытие по клавише Escape
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            const openModals = document.querySelectorAll('.modal-window[open]');
            openModals.forEach(modal => modal.close());
        }
    });

    // Логика data-submit-checkbox → data-submit-button
    document.addEventListener('change', (event) => {
        const checkbox = event.target.closest('[data-submit-checkbox]');
        if (!checkbox) return;

        // Ищем кнопку в пределах ближайшей модалки
        const container = checkbox.closest('.modal-window') || document;
        const submitButton = container.querySelector('[data-submit-button]');

        if (!submitButton) return;

        submitButton.disabled = !checkbox.checked;
    });
});